import { render, staticRenderFns } from "./input-price-widget.vue?vue&type=template&id=689a2c74&scoped=true"
import script from "./input-price-widget.vue?vue&type=script&lang=js"
export * from "./input-price-widget.vue?vue&type=script&lang=js"
import style0 from "./input-price-widget.vue?vue&type=style&index=0&id=689a2c74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689a2c74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('689a2c74')) {
      api.createRecord('689a2c74', component.options)
    } else {
      api.reload('689a2c74', component.options)
    }
    module.hot.accept("./input-price-widget.vue?vue&type=template&id=689a2c74&scoped=true", function () {
      api.rerender('689a2c74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/input-price-widget.vue"
export default component.exports